import React from 'react';
import { Col, FormGroup, Label, Row } from 'reactstrap';
import { Field } from 'formik';


const UploadFile = ({label,value}:any) => {

  return (
    <Row>
      <Col sm="12">
        <FormGroup>
          <Label>{label} <span className="txt-danger">*</span></Label>
          <Field
            className="form-control"
            type="file"
            name="logo"
            accept="image/*"
            value={value}
         
          />
        </FormGroup>
      </Col>
      
    </Row>
  );
};

export default UploadFile;
